const styles = () => ({
    containerForm: {
        position: 'relative',
        paddingBottom: '130px',
        paddingTop: '20px',
    },
    containerReport: {
        marginTop: '10px',
    },
    loading: {
        margin: '0',
    },
    centerProgress: {
        textAlign: 'center',
        margin: '10px 0',
    },
});

export default styles;
